import React, { useState } from "react";
import moment from "moment";

import Pagination from "./pagination";

import { Visibility } from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const AllOrders = ({ data, showType }) => {
  let history = useHistory();
  const [currentItem, setCurrentItem] = useState(1);
  const [itemPerPage] = useState(10);

  const indexOfLastItem = currentItem * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentItem(pageNumber);
  };

  return (
    <div
      className={`tab-pane fade ${showType === 3 && "show active"}`}
      id="all-md"
      role="tabpanel"
      aria-labelledby="all-tab-md"
      style={{ textAlignLast: "center" }}
    >
      <table
        id="dtBasicExample"
        className="table table-striped table-bordered table-hover table-lg"
        cellSpacing="0"
        width="100%"
      >
        <thead>
          <tr id="deniedOrdersRow">
            <th style={{ fontWeight: 500 }}>Sipariş Durumu</th>
            <th style={{ fontWeight: 500 }}>Sipariş No</th>
            <th style={{ fontWeight: 500 }}>Sipariş Tarihi</th>
            <th style={{ fontWeight: 500 }}>Müşteri Adı</th>
            <th style={{ fontWeight: 500 }}>Adres</th>
            <th style={{ fontWeight: 500 }}>Tutar</th>
            <th style={{ fontWeight: 500 }}>Sipariş Bilgisi</th>
          </tr>
        </thead>
        {currentItems.map((orders, index) => {
          return (
            <tbody key={index}>
              <tr id="allOrdersRow">
                {orders.order_state === 400 ? (
                  <td className="approve-field">
                    <span
                      className="label label-in-progress"
                      style={{ color: "#fff" }}
                    >
                      Onay Bekliyor
                    </span>
                  </td>
                ) : orders.order_state === 500 ? (
                  <td className="approve-field">
                    <span
                      className="label label-prepare"
                      style={{ color: "#fff" }}
                    >
                      Hazırlanıyor
                    </span>
                  </td>
                ) : orders.order_state === 600 ? (
                  <td className="approve-field">
                    <span
                      className="label label-approved"
                      style={{ color: "#fff" }}
                    >
                      Müşteriye Gidiyor
                    </span>
                  </td>
                ) : orders.order_state === 700 ? (
                  <td className="approve-field">
                    <span
                      className="label label-deliver"
                      style={{ color: "#fff" }}
                    >
                      Teslim Edildi
                    </span>
                  </td>
                ) : (
                  <td className="approve-field">
                    <span
                      className="label label-rejected"
                      style={{ color: "#fff" }}
                    >
                      Reddedildi
                    </span>
                  </td>
                )}
                <td>{orders.order_id}</td>
                <td>
                  {moment(orders.createdAt).locale("tr").format("L")}
                  <br />
                  {moment(orders.createdAt).locale("tr").format("LTS")}
                </td>
                <td>{orders.client_name}</td>
                <td>{orders.delivery_address}</td>
                <td>
                  {orders.total_discounted_price !== null
                    ? orders.total_discounted_price
                    : orders.total_price}{" "}
                  ₺
                </td>
                <td>
                  <button
                    type="button"
                    className="btn btn-blue btn-rounded btn-sm m-1 approve-buttons"
                    onClick={() => history.push("/orderdetail", orders)}
                    style={{ borderRadius: 7 }}
                  >
                    <Visibility style={{ width: 20, marginBottom: 3 }} />
                    <span style={{ marginLeft: 3, fontSize: 14 }}>
                      Detaylar
                    </span>
                  </button>
                </td>
              </tr>
            </tbody>
          );
        })}
      </table>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Pagination
          itemPerPage={itemPerPage}
          totalItem={data.length}
          paginate={paginate}
        />
      </div>
    </div>
  );
};

export default AllOrders;
